import { createStore } from 'vuex'
import { authentication } from './modules/authentication.module';
import { theme } from './modules/theme.module';
import { isTokenExpired } from '../utils/jwt';

export default createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    authentication,
    theme
  },
  plugins: [
    store => {
      const token = localStorage.getItem('token');
      const user = localStorage.getItem('user');

      if (token && user && !isTokenExpired(token)) {
        store.commit('authentication/addWebToken', {
          token,
          ...JSON.parse(user)
        });
      } else if (token || user) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    },
    store => {
      const stored = localStorage.getItem('theme');
      store.commit('theme/SET_DARK', stored === 'dark');
    }
  ]
})
